import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { User, UserRole } from '../../models/user';
import { CommonModule } from '@angular/common';
import { DialogComponent } from "../dialog/dialog.component";

@Component({
  selector: 'app-users',
  imports: [CommonModule, DialogComponent],
  templateUrl: './users.component.html',
  styleUrl: './users.component.css'
})
export class UsersComponent implements OnInit {
  users: User[] = [];
  filterRole: number | null = null;

  UserRole = UserRole;

  public showUnauthorized = false;

  public userRoleKeys: number[] = [];

  get filteredUsers(): User[] {
    if (this.filterRole === null) return this.users;
    return this.users.filter(u => u.role === this.filterRole);
  }

  setFilter(event: Event) {
    const val = (event.target as HTMLSelectElement).value;
    this.filterRole = val === '' ? null : Number(val);
  }

  constructor(private userService: UserService)
  {

  }

  ngOnInit() {
    this.userRoleKeys = Object.keys(UserRole).map(key => Number(key)).filter(key => !isNaN(key));

    this.userService.getFullUsers().subscribe({
      next: (result) => {
        this.users = result;
      },
      error: (err) => {
        if (err.status === 403) {
          this.showUnauthorized = true;
        }
      }
    });

  }

  toggleDisabled(event: Event, user: User) {
    const checkbox = event.target as HTMLInputElement;
    const newValue = checkbox.checked;

    this.userService.patchUserField(user.id, 'disabled', newValue).subscribe({
      next: () => {
        user.disabled = newValue;
        console.log(`User ${user.email} disabled set to ${newValue}`);
      },
      error: (err) => {
        // Revert the checkbox to the last known value.
        checkbox.checked = user.disabled === true;
        if (err.status === 403) {
          this.showUnauthorized = true;
        }
        console.error('Failed to update disabled flag', err);
      }
    });
  }

}
